import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    *{
        font-family: Roboto Flex, sans-serif;
        margin: 0;
        padding: 0;
        outline:0;
        box-sizing:border-box;
        -webkit-font-smoothing: antialiased;
    }
    #root{
        margin:0 auto;
    }

    .display-block-wide{
        display: none;
        @media (min-width: 1150px) {
            display: block;
        }
    }

    .async-hide { opacity: 0 !important}

    .display-block{
        display: none;
        @media (min-width: 1025px) {
            display: block;
        }
    }

    .display-block-tablet-mobile{
        display: none;

        @media (min-width: 768px) and (max-width: 1024px) {
            display: block;
        }

        @media (max-width: 456px) {
            display: block;
        }
    }

    .wider-paragraph {
        width: 100%;
        @media (min-width: 1025px) {
            width: 427px;
        }
    }
`;
